import { render, staticRenderFns } from "./welcome-carrier-registration-status.vue?vue&type=template&id=355a357e&scoped=true&"
import script from "./welcome-carrier-registration-status.vue?vue&type=script&lang=js&"
export * from "./welcome-carrier-registration-status.vue?vue&type=script&lang=js&"
import style0 from "./welcome-carrier-registration-status.vue?vue&type=style&index=0&id=355a357e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355a357e",
  null
  
)

export default component.exports